<div #cellElement style="width:auto; overflow: hidden; text-overflow: ellipsis" [matTooltip]="toolTipText">
  {{ text | translate }}
</div>
